import {WellnessLane, WellnessMedia} from "@irati/types"
import service from "@irati-tracking/tracker"

interface ClickMediaDataInterface {
  lane?: WellnessLane
  lanePosition?: number
  isRelatedMedia?: boolean
  mediaPositionInLane?: number
}

class WellnessTrackingEvents {
  viewWellnessHome() {
    service.trackWellnessEvent("wellness_view_home")
  }
  clickMedia(media: WellnessMedia, clickMediaData?: ClickMediaDataInterface) {
    const data = {
      media_tile_name: media.title,
      media_tile_lane_name: clickMediaData?.lane?.title,
      media_tile_lane_position: clickMediaData?.lanePosition,
      media_category: media.category.name,
      is_related_media: clickMediaData?.isRelatedMedia,
      media_duration: media.duration,
      media_position_in_lane: clickMediaData?.mediaPositionInLane,
      media_price: media.price ? media.price : 0
    }
    service.trackWellnessEvent("wellness_click_content_tile", data)
  }

  viewMediaContent(media: WellnessMedia) {
    const data = {
      media_type: media.type,
      media_name: media.title,
      media_author: media.author.name,
      media_provider: media.provider.name,
      media_category: media.category.name,
      media_duration: media.duration,
      media_price: media.price ? media.price : 0
    }
    service.trackWellnessEvent("wellness_view_content", data)
  }

  startMedia(media: WellnessMedia) {
    const data = {
      media_name: media.title,
      media_id: media.uuid,
      media_author: media.author.name,
      media_provider: media.provider.name,
      media_type: media.type,
      media_category: media.category.name,
      media_duration: media.duration
    }
    service.trackWellnessEvent("wellness_start_video", data)
  }

  stopMedia(media: WellnessMedia) {
    const data = {
      media_name: media.title,
      media_id: media.uuid,
      media_author: media.author.name,
      media_provider: media.provider.name,
      media_type: media.type,
      media_category: media.category.name,
      media_duration: media.duration
    }
    service.trackWellnessEvent("wellness_finish_video", data)
  }

  progressMedia(media: WellnessMedia, progress: number) {
    const data = {
      progress,
      media_name: media.title,
      media_id: media.uuid,
      media_author: media.author.name,
      media_provider: media.provider.name,
      media_type: media.type,
      media_category: media.category.name,
      media_duration: media.duration,
      media_price: media.price ? media.price : 0
    }
    service.trackWellnessEvent("wellness_media_playback", data)
  }

  viewCategorySelected(categoryName: string) {
    const data = {
      category_name: categoryName
    }
    service.trackWellnessEvent("wellness_select_category", data)
  }

  viewCategoryTag(tagName: string) {
    const data = {
      wellness_tag_name: tagName
    }
    service.trackWellnessEvent("wellness_select_tag", data)
  }

  clickBanner(bannerTitle: string) {
    const data = {
      wellness_banner_title: bannerTitle
    }
    service.trackWellnessEvent("wellness_click_banner", data)
  }

  clickExplore() {
    service.trackWellnessEvent("wellness_click_explore")
  }

  wellnessLiveRegister() {
    service.trackWellnessEvent("wellness_live_register")
  }

  wellnessLiveDeregister() {
    service.trackWellnessEvent("wellness_live_deregister")
  }

  startRentMedia(media: WellnessMedia) {
    const data = {
      media_name: media.title,
      media_price: media.price,
      media_rental_duration: `${media.rentalPeriod} ${media.rentalPeriodUnit}`
    }
    service.trackWellnessEvent("wellness_start_rent_media", data)
  }
  completeRentMedia(media: WellnessMedia) {
    const data = {
      media_name: media.title,
      media_price: media.price,
      media_rental_duration: `${media.rentalPeriod} ${media.rentalPeriodUnit}`
    }
    service.trackWellnessEvent("wellness_complete_rent_media", data)
  }

  clickFeaturedLane() {
    service.trackWellnessEvent("wellness_click_featured_lane")
  }
}

export default new WellnessTrackingEvents()
